import { useNavigate, useParams } from "react-router-dom";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import PageContainer from "components/PageContainer";
import CallAgentMetricsTable from "components/call_metrics_table/CallMetricsTableV3";
import setPageTitle from "helpers/title";
import TotalCallsChart from "routes/dashboard/TotalCallsChart";
import CallDashboardSummaryStats from "routes/dashboard/CallDashboardSummaryStats";
import CallsBreakDownByDispositionChart from "routes/dashboard/CallBreakdownByDisposition";
import CallsBreakDownByDialSessionChart from "routes/dashboard/CallsBreakDownByDialSessionChart";
import { CallDashboardFilters } from "routes/dashboard/CallDashboardFilters";

const tabs = [
  {
    value: "totalCalls",
    label: "Total Calls",
    Content: TotalCallsChart,
  },
  {
    value: "agentMetrics",
    label: "Agent Metrics",
    Content: CallAgentMetricsTable,
  },
  {
    value: "dispositionBreakdown",
    label: "Disposition Breakdown",
    Content: CallsBreakDownByDispositionChart,
  },
  {
    value: "dialSessionBreakdown",
    label: "Dial Session Breakdown",
    Content: CallsBreakDownByDialSessionChart,
  },
];
const tabValues = tabs.map(t => t.value);

const CallDashboard = () => {
  const { tab: activeTab } = useParams();
  const navigate = useNavigate();
  setPageTitle("Call Dashboard");

  const handleTabChange = tab => {
    navigate({
      pathname: `/call_dashboard/${tab}`,
      search: window.location.search,
    });
  };

  return (
    <PageContainer>
      <div className="tw:flex tw:flex-1 tw:gap-4 tw:w-full">
        <CallDashboardFilters />

        <div className="tw:flex tw:flex-1 tw:flex-col tw:min-w-0">
          <CallDashboardSummaryStats />
          <Tabs
            value={activeTab ?? tabValues[0]}
            onValueChange={handleTabChange}
            className="tw:flex-1 tw:gap-4"
          >
            <TabsList>
              {tabs.map(t => (
                <TabsTrigger key={t.value} value={t.value}>
                  {t.label}
                </TabsTrigger>
              ))}
            </TabsList>
            {tabs.map(({ value, Content }) => (
              <TabsContent key={value} value={value}>
                <Card className="tw:h-full tw:flex tw:p-4">
                  <Content />
                </Card>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </PageContainer>
  );
};
export default CallDashboard;
